<template>
	<div class="cinema my-20 px-20 py-20 rounded box-shadow flex justify-between item-center hover-box-shadow-blue">
		<div class="text-left">
			<div class="text-lg dark hover-red hand">{{cinema.cmaName}}</div>
			<div class="my-10 text-md gray">地址：{{cinema.cmaAddress}}</div>
			<div class="text-sm flex item-center">
				<div class="cinema-tag mr-10"
					v-for="(service,index) of cinema.cinemaSpicalList"
					:key="'service-'+index">{{service.spe_name}}
				</div>
			</div>
		</div>
		<div class="flex item-center">
			<div class="text-right">
				<div class="text-md" v-if="cinema.cmaCost">
					<span class="red">￥{{cinema.cmaCost}}</span>
					<span class="dark ml-5">起</span>
				</div>
				<div class="text-md" v-else>
					<span class="red">暂无</span>
				</div>
				
				
				<div class="mt-10 text-sm gray">{{cinema.cmaAway}}</div>
			</div>
			<button class="cinema-btn-buy ml-40 text-md hand">选座购票</button>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['cinema']
	}
</script>

<style>
	.cinema-tag{padding: 4px 10px; border: 1px solid #aac; color: #aac; border-radius: 4px;}
	.cinema-btn-buy{padding: 10px 20px; outline: none; background-color: #C11; color: #fff; border: 0px; border-radius: 6px;}
	.cinema-btn-buy:hover{background-color: #E1251B;}
</style>
